import { useState } from 'react'
import { Button, notification } from 'antd'
import { useDispatch } from 'react-redux'
import { menuBuilderMissingProductsCopy as copy } from 'src/constants/menuBuilderCopy'
import { fetchVenueProducts } from 'src/features/VenueProductsSlice'
import { getProducts } from 'src/features/RecipeBuilderSlice'
import {
  formatMissingProductsBody,
  getMissingIngredientLabel,
} from 'src/utils/menuBuilderMissingProducts'
import { addMissingProductsToShoppingList } from 'src/utils/menuBuilderMissingProductsApi'

const MissingProductsBanner = ({
  missingProducts = [],
  venueId,
  onProductsAdded,
  compact = false,
  context = 'detail',
}) => {
  const dispatch = useDispatch()
  const [isAdding, setIsAdding] = useState(false)

  if (!missingProducts.length) {
    return null
  }

  const handleAddMissing = async () => {
    if (!venueId) {
      return
    }

    try {
      setIsAdding(true)
      const response = await addMissingProductsToShoppingList(
        venueId,
        missingProducts,
      )

      if (response?.success) {
        notification.success({
          message: copy.addSuccessTitle,
          description: formatMissingProductsBody(
            response?.data?.totalAdded ?? missingProducts.length,
            copy.addSuccessBodyTemplate,
          ),
        })
        await Promise.all([
          dispatch(fetchVenueProducts(venueId)),
          dispatch(getProducts(venueId)),
        ])
        onProductsAdded?.(response)
        return
      }

      throw new Error(response?.message || copy.addFailedBody)
    } catch {
      notification.warning({
        message: copy.addFailedTitle,
        description: copy.addFailedBody,
      })
    } finally {
      setIsAdding(false)
    }
  }

  return (
    <div
      style={{
        margin: compact ? '0 0 10px' : '0 0 12px',
        padding: compact ? '10px 12px' : '12px 14px',
        borderRadius: 10,
        backgroundColor: '#fff2e8',
        border: '1px solid #ffb366',
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 14, color: '#d46b08' }}>
        {copy.title}
      </div>
      <div
        style={{
          fontSize: 13,
          lineHeight: 1.4,
          color: '#d46b08',
          marginTop: 4,
        }}
      >
        {formatMissingProductsBody(missingProducts.length, copy.bodyTemplate)}
      </div>
      {context === 'editor' && copy.editBlockedBody ? (
        <div
          style={{ fontSize: 13, color: '#d46b08', marginTop: 4, opacity: 0.9 }}
        >
          {copy.editBlockedBody}
        </div>
      ) : null}
      <div
        style={{
          fontWeight: 700,
          fontSize: 12,
          color: '#d46b08',
          marginTop: 8,
        }}
      >
        {copy.listTitle}
      </div>
      <ul
        style={{
          margin: '4px 0 0',
          paddingLeft: 18,
          color: '#d46b08',
          fontSize: 12,
        }}
      >
        {missingProducts.map((missing, idx) => (
          <li key={`${missing.index}-${idx}`}>
            {getMissingIngredientLabel(missing)} — {missing.reason}
          </li>
        ))}
      </ul>
      <div style={{ marginTop: 10 }}>
        <Button
          type='primary'
          size='small'
          loading={isAdding}
          onClick={handleAddMissing}
          style={{ backgroundColor: '#d46b08', borderColor: '#d46b08' }}
        >
          {copy.addCta}
        </Button>
      </div>
    </div>
  )
}

export default MissingProductsBanner
